import React, { useState, useEffect, useCallback } from 'react';
import { Container, Tabs, Tab, Box, Typography, Paper } from '@mui/material';
import PontoCamera from '../components/PontoCamera';
import PontoManual from '../components/PontoManual';
import PontoHistorico from '../components/PontoHistorico';
import PontoRelatorio from '../components/PontoRelatorio';
import api from '../services/api';
import { pageTitleSx } from '../styles/uiTokens';

function PontoPage() {
  const [tab, setTab] = useState(0);
  const [funcionarios, setFuncionarios] = useState([]);
  const [refreshKey, setRefreshKey] = useState(0);

  const fetchFuncionarios = useCallback(() => {
    api.get('/ponto/portaria-funcionarios')
      .then((response) => {
        setFuncionarios(response.data.data || []);
      })
      .catch((err) => {
        console.error('Erro ao buscar funcionários:', err);
      });
  }, []);

  useEffect(() => {
    fetchFuncionarios();
  }, [fetchFuncionarios]);

  const handlePontoRegistrado = () => {
    setRefreshKey((k) => k + 1);
  };

  return (
    <Container maxWidth="md" sx={{ mt: 2, mb: 4 }}>
      <Typography variant="h4" gutterBottom align="center" sx={{ ...pageTitleSx, mb: 3 }}>
        Registro de Ponto
      </Typography>

      <Paper sx={{ mb: 3 }}>
        <Tabs
          value={tab}
          onChange={(e, v) => setTab(v)}
          variant="fullWidth"
          indicatorColor="primary"
          textColor="primary"
        >
          <Tab label="Câmera" />
          <Tab label="Manual" />
          <Tab label="Histórico" />
          <Tab label="Relatório" />
        </Tabs>
      </Paper>

      {tab === 0 && (
        <Box key={`camera-${refreshKey}`}>
          {funcionarios.length === 0 ? (
            <Typography color="text.secondary" textAlign="center" sx={{ py: 4 }}>
              Nenhum funcionário cadastrado para esta empresa.
            </Typography>
          ) : (
            <PontoCamera onPontoRegistrado={handlePontoRegistrado} />
          )}
        </Box>
      )}

      {tab === 1 && (
        <Box key={`manual-${refreshKey}`}>
          {funcionarios.length === 0 ? (
            <Typography color="text.secondary" textAlign="center" sx={{ py: 4 }}>
              Nenhum funcionário cadastrado para esta empresa.
            </Typography>
          ) : (
            <PontoManual
              funcionarios={funcionarios}
              onPontoRegistrado={handlePontoRegistrado}
            />
          )}
        </Box>
      )}

      {tab === 2 && (
        <Box key={`historico-${refreshKey}`}>
          <PontoHistorico />
        </Box>
      )}

      {tab === 3 && (
        <Box key="relatorio">
          <PontoRelatorio />
        </Box>
      )}
    </Container>
  );
}

export default PontoPage;
